<template>
  <div
    class="details"
    :class="[
      {'details--open': open}
    ]"
  >
    <div
      class="details__summary details__summary--underline"
      tabindex="0"
      role="button"
      :id="summary_id"
      :aria-expanded="open"
      :aria-pressed="open"
      :aria-controls="content_id"
      @click="toggle"
      @keydown.space.prevent="preventDefault"
      @keyup.enter="toggle"
      @keyup.space="toggle"
    >
      <div class="details__summary-text">{{summary}}</div>
    </div>
    <div
      v-if="open"
      class="details__content"
      role="region"
      :id="content_id"
      :aria-hidden="!open"
      :aria-labelledby="summary_id"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
const uuidv4 = require('uuid/v4')

export default {
  name: 'VueDetails',
  props: {
    open: {
      type: Boolean,
      default: false,
      twoWay: true
    },
    summary: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      summary_id: null,
      content_id: null
    }
  },
  mounted () {
    this.summary_id = uuidv4()
    this.content_id = uuidv4()
  },
  methods: {
    toggle () {
      this.$emit('toggle')
    },
    preventDefault () {
      // Prevent default behavior of space... scroll page down
    }
  }
}
</script>

<style>

/* Details Summary */
.details__summary {
  cursor: pointer;
  display:block;
  outline:none;
  position:relative;
}
.details__summary:before {
  content:'';
  position:absolute;
  top:0;
  display:inline-block;
  width: 1.5rem;
  height: 1.5rem;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='36px' height='36px' viewBox='0 0 36 36' xmlns='http://www.w3.org/2000/svg' fill='%23dc0000' stroke='rgba(0,0,0,0)'%3E %3Cg%3E %3Cpath d='M12 26.395l1.417 1.41 9.89-9.93L13.416 8l-1.413 1.415 8.48 8.465'/%3E %3C/g%3E %3C/svg%3E");
  background-size: 1em 1em;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-position: center left;
  background-size: 1.5rem;
  transform: translate(0,-2px);
  transition: transform 0.15s ease-out;
}
.details__summary-text {
  margin-left:1.5rem;
}
.details--open .details__summary:before {
  transform: rotate(90deg) translate(-2px, 0);
}
/*
.details__summary::-webkit-details-marker {
  display:none;
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .details__summary {
    display:none;
  }
}
@supports (-ms-accelerator:true) {
  .details__summary {
    display:none !important;
  }
} */
.details__summary--underline:hover .details__summary-text,
.details__summary--underline:focus .details__summary-text {
  text-decoration: underline;
  text-decoration-color:#dc0000;
}
.details__content {
  padding:1rem 1.5rem 0 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/common/VueDetails.vue